import React, { useEffect, useMemo, useState } from 'react';
import DataGridGenerico from '../../../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../../../components/dataGrid/columnHelpers';
import { CustomDialog } from "../../../../../components/customDialog/CustomDialog";
import { Grid } from '@mui/material';
import { TextInput } from '../../../../../components/textInput/TextInput';
import { RenderInputsRowByType } from '../../../../../components/formGroupGenerator/RenderInputRowByType';
import { RenderInputByTypeMobile } from '../../../../../components/formGroupGenerator/RenderInputByTypeMobile';

const OSColumns = [
    {
        field: 'codigoCliente',
        headerName: 'Cod Cliente',
        flex: 0.33
    },
    {
        field: 'nombre',
        headerName: 'Nombre',
        flex: 0.33
    },
    {
        field: 'condicionPago',
        headerName: 'Condicion de Pago',
        flex: 0.33
    }
];

export const OSSapInput = ({
    input,
    idDelegacion,
    rows = [],
    value,
    paginationStatus,
    handleChangePaginationStatus,
    totalCount,
    filterStatus,
    setFilterStatus,
    handleRowClick,
}) => {
    const [openModal, setOpenModal] = useState(false);

    const columns = useMemo(() => (generateColumnsDefaultConfiguration(OSColumns)), [OSColumns]);

    const handleOpenModal = () => setOpenModal(true);

    const handleClose = () => {
        setOpenModal(false);
    }

    return <>
        <Grid size={{ xs: 100, sm: 50, md: input.col, lg: input.col }}>
            <TextInput
                key={value}
                label={input.displayName}
                name={input.name}
                onClick={() => handleOpenModal()}
                placeholder='Buscar'
                value={value}
                disabled={input.disabled}
                searchIcon
            />
        </Grid>
        <CustomDialog
            maxWidth='lg'
            fullWidth
            onCancel={handleClose}
            open={openModal}
            cancelText='Cerrar'
            title='OS SAP'
        >
            <p>Haz click sobre un OS para agregarlo y seguir con el formulario..</p>
            <Grid
                container
            // justifyContent={'space-between'}
            >
                <Grid sx={{ my: 2.5 }} size={{ xs: 12, md: 6 }}>
                    <TextInput
                        placeholder='Filtrar'
                        value={filterStatus}
                        searchIcon
                        onChange={(e) => setFilterStatus(e.target.value)}
                        onClearButtonClick={() => setFilterStatus('')}
                    />
                </Grid>
                <Grid size={{ xs: 12 }}>
                    <DataGridGenerico
                        hideFooterPagination={false}
                        toolbar={false}
                        columns={columns}
                        rows={rows}
                        onPageChange={(page) =>
                            handleChangePaginationStatus(prev => ({
                                ...prev,
                                page: page
                            }))
                        }
                        onPageSizeChange={(pageSize) =>
                            handleChangePaginationStatus(prev => ({
                                ...prev,
                                pageSize: pageSize,
                                page: 0
                            }))
                        }
                        pageSize={paginationStatus.pageSize}
                        totalCount={totalCount}
                        currentPage={paginationStatus.page}
                        onRowClick={(row) => {
                            handleRowClick(row);
                            handleClose()
                        }}
                    />
                </Grid>
            </Grid>
        </CustomDialog>
    </>;
}